const Data = [
  {
    name: "Abhishek Tanwar",
    position: "Design Head",
    imageUrl: "/assets/images/members/Heads26/AbhishekTanwar.JPG",
    facebookLink: "https://www.facebook.com/share/1HaCpwypCJ/",
    email: "Abhishektanwar753@gmail.com",
    linkedinLink: "https://www.linkedin.com/in/abhishektanwar01?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Mansi",
    position: "Design Head",
    imageUrl: "/assets/images/members/Heads26/Mansi.jpg",
    facebookLink: "https://www.facebook.com/share/1Q8rJCJYuv/",
    email: "mansi0052.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/mansi-624520328?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  }
];

export default Data;